import * as React from 'react';
import SponsorImage from './sponser-image';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';
import FinnLogoSvg from '../assets/finn-logo-svg';

type TSponsorHeader = {
    contentMarketing: TImprovedContentMarketing;
    className?: string;
    forceSmall?: boolean;
};

export const SponsorHeader = ({
    contentMarketing,
    className,
    forceSmall = false,
}: TSponsorHeader) => {
    return (
        <div
            className={`flex w-full justify-between pb-8 items-center px-8 md:pl-0 ${
                className || ''
            }`}
        >
            <div className={`gray-500 ${forceSmall ? 'text-14' : 'text-16'}`}>
                <div className={'flex items-center'}>
                    {!forceSmall && <FinnLogoSvg />}
                    <span className={forceSmall ? '' : 'ml-8'}>
                        Annonsørinnhold
                    </span>
                </div>
            </div>
            <SponsorImage
                contentMarketing={contentMarketing}
                forceSmall={forceSmall}
            />
        </div>
    );
};

export default SponsorHeader;
